<div class="banner" [ngClass]="type">
	<p class="banner-text">
		<ng-content></ng-content>
	</p>
</div>